/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Metric } from './Metric';
import {
    MetricFromJSON,
    MetricFromJSONTyped,
    MetricToJSON,
    MetricToJSONTyped,
} from './Metric';

/**
 * 
 * @export
 * @interface BusinessReportPaymentMethodsNetAmountResponse
 */
export interface BusinessReportPaymentMethodsNetAmountResponse {
    /**
     * 
     * @type {Array<Metric>}
     * @memberof BusinessReportPaymentMethodsNetAmountResponse
     */
    data: Array<Metric>;
}

/**
 * Check if a given object implements the BusinessReportPaymentMethodsNetAmountResponse interface.
 */
export function instanceOfBusinessReportPaymentMethodsNetAmountResponse(value: object): value is BusinessReportPaymentMethodsNetAmountResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function BusinessReportPaymentMethodsNetAmountResponseFromJSON(json: any): BusinessReportPaymentMethodsNetAmountResponse {
    return BusinessReportPaymentMethodsNetAmountResponseFromJSONTyped(json, false);
}

export function BusinessReportPaymentMethodsNetAmountResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessReportPaymentMethodsNetAmountResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(MetricFromJSON)),
    };
}

export function BusinessReportPaymentMethodsNetAmountResponseToJSON(json: any): BusinessReportPaymentMethodsNetAmountResponse {
    return BusinessReportPaymentMethodsNetAmountResponseToJSONTyped(json, false);
}

export function BusinessReportPaymentMethodsNetAmountResponseToJSONTyped(value?: BusinessReportPaymentMethodsNetAmountResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(MetricToJSON)),
    };
}

